export const MIN_HEIGHT_CM = 3;
export const MAX_HEIGHT_CM = 30;
export const DEFAULT_HEIGHT_CM = 12;
export const MAX_CHARS = 40;
export const DEFAULT_TEXT = "Alpine Customs";

/** Extrusion depth of the letters - a configurator option, stored per order (see line-item-fields.ts). */
export const MIN_DEPTH_MM = 10;
export const MAX_DEPTH_MM = 50;
export const DEFAULT_DEPTH_MM = 10;

/**
 * Placeholder pricing, not yet confirmed with the client - see
 * src/lib/pricing.ts. Easy to tune here without touching call sites.
 */
export const PRICE_BASE_CHF = 39;
export const PRICE_PER_CM2_CHF = 0.8;

/** Usable print bed (square) - letters larger than this get flagged in the order mail. */
export const PRINT_BED_MM = 250;
